'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isNotGraphqlPrivateType = require('../isNotGraphqlPrivateType');

var _isNotGraphqlPrivateType2 = _interopRequireDefault(_isNotGraphqlPrivateType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (resource, type, _ref) {
    var excludeFields = _ref.excludeFields;
    return resource.fields.filter(_isNotGraphqlPrivateType2.default).filter(function (field) {
        if (excludeFields) {
            if (Array.isArray(excludeFields)) {
                return !excludeFields.includes(field.name);
            }

            if (typeof excludeFields === 'function') {
                return !excludeFields(field, resource, type);
            }
        }

        return true;
    }).map(function (f) {
        return f.name;
    }).join(' ');
};


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/introspection/buildQueriesForResource/buildFieldList.js
// module id = 932
// module chunks = 0